<template lang="pug">
  v-dialog(v-bind="$attrs" v-on="$listeners")
    slot
</template>

<script>
export default {
  name: 'YzDialog',
  watch: {
    value(val) {
      this.$store.commit('ui/setDialogVisibility', val)
    }
  },
  mounted() {
    this.$store.commit('ui/setDialogVisibility', this.value)
  },
  beforeDestroy() {
    this.$store.commit('ui/setDialogVisibility', false)
  }
}
</script>
